/* @ngInject */

export default (PersonalTitle, Address) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function ContactForValuation(idSecurity, loanParty, other, isOther) {
    this.idSecurity = idSecurity;
    this.loanParty = loanParty;
    this.other = other;
    this.isOther = isOther;

    _.each(this.other, (val, key, obj) => {
      if (key === 'title' && typeof val === 'number') {
        switch (val) {
          case 0:
            obj[key] = PersonalTitle.none;
            break;
          case 1:
            obj[key] = PersonalTitle.mr;
            break;
          case 2:
            obj[key] = PersonalTitle.ms;
            break;
          case 3:
            obj[key] = PersonalTitle.mrs;
            break;
          case 4:
            obj[key] = PersonalTitle.dr;
            break;
          case 5:
            obj[key] = PersonalTitle.miss;
            break;
          default:
            break;
        }
      }
      if (key === 'title' && typeof val !== 'number') {
        obj[key] = PersonalTitle.of(val?.name);
      }
    });
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  ContactForValuation.Blank = function (idSecurity, idPrimaryClient) {
    return ContactForValuation.Build({
      idSecurity,
      loanParty: idPrimaryClient,
      other: {
        id: _.uuid(),
        companyName: '',
        title: PersonalTitle.none,
        firstName: '',
        surname: '',
        phoneCode: '',
        phone: '',
        type: 0,
        address: Address.blank()
      },
      isOther: false
    });
  };
  ContactForValuation.Build = function (data) {
    return new ContactForValuation(
      data.idSecurity ? data.idSecurity : '',
      data.loanParty ? data.loanParty : '',
      data.other
        ? data.other
        : {
            id: _.uuid(),
            companyName: '',
            title: PersonalTitle.none,
            firstName: '',
            surname: '',
            phoneCode: '',
            phone: '',
            type: 0,
            address: Address.blank()
          },
      data.isOther ? data.isOther : false
    );
  };

  return ContactForValuation;
};
